var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', _vm._b({
    staticClass: "qn-image",
    attrs: {
      "src": _vm.previewImg,
      "alt": "图片"
    }
  }, 'img', _vm.$attrs, false))
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-713823e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-713823e1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QnImage/index.vue
// module id = n/eG
// module chunks = 182